<template>
  <div class="countdown">
    <div
      v-if="
        remaining.days.value > 0 ||
          (remaining.years.value > 0 && remaining.days.value == 0)
      "
      class="fancy-countdown flex flex-row justify-center items-center"
    >
      <div
        v-if="remaining.years.value != 0"
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        <span class="text-2x font-bold leading-14 mb-2">{{
          remaining.years.value
        }}</span>
        <span class="text-2xs uppercase font-bold leading-10">{{
          remaining.years.label
        }}</span>
      </div>
      <div
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        <span
          class="text-2x font-bold leading-14 mb-2"
          >{{ remaining.days.value &lt; 10 ? '0' + remaining.days.value : remaining.days.value}}</span
        >
        <span class="text-2xs uppercase font-bold leading-10">{{
          remaining.days.label
        }}</span>
      </div>
      <div
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        <span
          class="text-2x font-bold leading-14 mb-2"
          >{{ remaining.hours.value &lt; 10 ? '0' + remaining.hours.value : remaining.hours.value}}</span
        >
        <span class="text-2xs uppercase font-bold leading-10 ">{{
          remaining.hours.label
        }}</span>
      </div>
    </div>
    <div
      v-else
      class="fancy-countdown flex flex-row justify-center items-center"
    >
      <div
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        {{
          remaining.hours.value &lt; 10
            ? '0' + remaining.hours.value
            : remaining.hours.value
        }}
      </div>
      :
      <div
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        {{
          remaining.minutes.value &lt; 10
            ? '0' + remaining.minutes.value
            : remaining.minutes.value
        }}
      </div>
      :
      <div
        class="flex flex-col w-40 h-40 my-5 mx-2 justify-center items-center shadow rounded bg-primary-really-fancy"
      >
        {{
        remaining.seconds.value &lt; 10
          ? '0' + remaining.seconds.value
          : remaining.seconds.value
        }}
      </div>
    </div>
  </div>
</template>

<script>
import * as workerTimers from 'worker-timers'
import {
  addDays,
  addHours,
  addMinutes,
  addYears,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  differenceInYears
} from 'date-fns'

export default {
  name: 'CountDownFancy',
  props: {
    endDate: {
      type: [String, Boolean],
      default: false
    }
  },
  data() {
    return {
      remaining: {
        years: {
          label: this.$t('general.Year'),
          value: 0
        },
        days: {
          label: this.$t('general.Day'),
          value: 0
        },
        hours: {
          label: this.$t('general.Hour'),
          value: 0
        },
        minutes: {
          label: this.$t('general.Minute'),
          value: 0
        },
        seconds: {
          label: this.$t('general.Second'),
          value: 0
        }
      },
      tick: false
    }
  },
  mounted() {
    if (this.tick !== false) {
      workerTimers.clearInterval(this.tick)
      this.tick = false
    }

    this.calcRemainingTime(this.endDate)
    this.tick = workerTimers.setInterval(() => {
      this.calcRemainingTime(this.endDate)
    }, 500)
  },
  methods: {
    calcRemainingTime(date) {
      // Kukás iPhone nem kezel bármilyen dátumformátumot ezért konvertálni kell, viva la epül
      const arr = date.split(/[- :]/)
      date = new Date(
        arr[0],
        arr[1] - 1,
        arr[2],
        arr[3] !== undefined ? arr[3] : 0,
        arr[4] !== undefined ? arr[4] : 0,
        arr[5] !== undefined ? arr[5] : 0
      )

      let today = new Date()

      if (date < today) {
        return false
      }

      let temp

      temp = differenceInYears(date, today)
      this.remaining.years.value = temp
      today = addYears(today, temp)

      temp = differenceInDays(date, today)
      this.remaining.days.value = temp
      today = addDays(today, temp)

      temp = differenceInHours(date, today)
      this.remaining.hours.value = temp
      today = addHours(today, temp)

      temp = differenceInMinutes(date, today)
      this.remaining.minutes.value = temp
      today = addMinutes(today, temp)

      temp = differenceInSeconds(date, today)
      this.remaining.seconds.value = temp

      if (
        !(
          (this.remaining.days.value > 0) &
          (this.remaining.months > 0) &
          (this.remaining.years.value > 0)
        )
      ) {
      }
    }
  }
}
</script>

<style scoped>
.bg-primary-really-fancy {
  background: linear-gradient(-45deg, #13afb6 0%, #03659c 50%, #b6f2f5 100%);
}
</style>
